<hlm-dialog [state]="open() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <!-- Wide, so the template previews are legible, and the same height on every tab
       so switching does not resize it; only the middle scrolls, the header and the
       buttons stay in view. -->
  <hlm-dialog-content
    *hlmDialogPortal
    class="flex h-[90vh] max-w-5xl flex-col gap-4 overflow-hidden sm:max-w-5xl">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>Neues Design</h3>
      <p hlmDialogDescription>
        Starte mit einer Vorlage, deiner eigenen Datei oder einer leeren Seite. Alles Weitere
        passiert im Editor.
      </p>
    </div>

    <div class="-mx-1 min-h-0 flex-1 space-y-4 overflow-y-auto px-1">
      <div class="space-y-3">
        <div class="space-y-1">
          <span hlmLabel>Für</span>
          <div class="flex gap-2" role="group" aria-label="Gutschein-Typ">
            <button
              hlmBtn
              size="sm"
              type="button"
              [variant]="voucherType() === 'money' ? 'default' : 'outline'"
              [attr.aria-pressed]="voucherType() === 'money'"
              (click)="setType('money')">
              Wert-Gutscheine
            </button>
            <button
              hlmBtn
              size="sm"
              type="button"
              [variant]="voucherType() === 'product' ? 'default' : 'outline'"
              [attr.aria-pressed]="voucherType() === 'product'"
              (click)="setType('product')">
              Produkt-Gutscheine
            </button>
          </div>
          @if (voucherType() === 'product' && !productsEnabled()) {
            <p hlmMuted class="text-xs">
              Produkt-Gutscheine sind noch ausgeschaltet. Das Design kannst du jetzt schon anlegen
              und auswählen; verkauft wird damit, sobald du Produkt-Gutscheine in der Gutschein-App
              einschaltest.
            </p>
          }
        </div>
        <div class="space-y-1">
          <label hlmLabel for="new-design-name">Name (optional)</label>
          <input
            hlmInput
            id="new-design-name"
            type="text"
            maxlength="100"
            placeholder="z. B. Weihnachten 2027"
            [value]="name()"
            (input)="onName($event)" />
        </div>
      </div>

      <hlm-tabs [tab]="source()" class="w-full">
        <hlm-tabs-list variant="line" class="w-full">
          <button hlmTabsTrigger="template" type="button" (click)="source.set('template')">
            Vorlage
          </button>
          <button hlmTabsTrigger="upload" type="button" (click)="source.set('upload')">
            Hochladen
          </button>
          <button hlmTabsTrigger="blank" type="button" (click)="source.set('blank')">
            Leere Seite
          </button>
        </hlm-tabs-list>

        <div hlmTabsContent="template" class="pt-4">
          @if (templatesError(); as message) {
            <div hlmAlert variant="destructive">
              <ng-icon name="lucideTriangleAlert" />
              <p hlmAlertTitle>{{ message }}</p>
              <p hlmAlertDescription>
                <button hlmBtn variant="link" size="sm" type="button" (click)="loadTemplates()">
                  Erneut versuchen
                </button>
              </p>
            </div>
          } @else {
            <app-template-picker
              [templates]="templates()?.templates ?? null"
              [voucherType]="voucherType()"
              [selectedKey]="selectedTemplate()?.key ?? null"
              [showPreviews]="open() && source() === 'template'"
              (select)="selectedTemplate.set($event)"
              (uploadBranding)="goToBranding()" />
            <p hlmMuted class="mt-3 text-xs">
              Die Vorlagen verwenden deine Hauptfarbe, Logo und Banner aus der Gutschein-App. Alles
              lässt sich danach im Editor ändern.
            </p>
          }
        </div>

        <div hlmTabsContent="upload" class="space-y-3 pt-4">
          <p class="text-sm">
            PDF, SVG oder Bild (PNG, JPG, WEBP), eine Seite, beliebiges Seitenformat. Die Datei wird
            der Hintergrund des Designs; die Elemente platzierst du darauf im Editor.
          </p>
          <p hlmMuted class="text-xs">
            Bilder am besten mit 300 dpi in Druckgröße exportieren. Bei SVG den Text vor dem Export
            in Pfade umwandeln, damit deine Schriften erhalten bleiben.
          </p>
          <button hlmBtn type="button" [disabled]="busy()" (click)="openPicker()">
            @if (busy()) {
              <hlm-spinner />
              Design wird geprüft und umgewandelt…
            } @else {
              <ng-icon name="lucideFileUp" />
              Datei auswählen
            }
          </button>
          <input
            #fileInput
            type="file"
            class="sr-only"
            accept="application/pdf,image/svg+xml,image/png,image/jpeg,image/webp,image/heic,image/heif,.pdf,.svg,.png,.jpg,.jpeg,.webp,.heic,.heif"
            aria-label="Design-Datei auswählen"
            (change)="onFileSelected($event)" />
        </div>

        <div hlmTabsContent="blank" class="pt-4">
          <app-blank-page-form [presets]="templates()?.page_presets ?? []" [(page)]="blankPage" />
        </div>
      </hlm-tabs>

      @if (error(); as message) {
        <div hlmAlert variant="destructive">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertDescription>{{ message }}</p>
        </div>
      }
    </div>

    <div hlmDialogFooter class="shrink-0 border-t pt-4">
      <button hlmBtn variant="outline" type="button" [disabled]="busy()" (click)="close.emit()">
        Abbrechen
      </button>
      @if (source() !== 'upload') {
        <button hlmBtn type="button" [disabled]="!canCreate()" (click)="create()">
          @if (busy()) {
            <hlm-spinner />
          }
          {{ source() === 'template' ? 'Mit dieser Vorlage starten' : 'Leere Seite anlegen' }}
        </button>
      }
    </div>
  </hlm-dialog-content>
</hlm-dialog>
